import { Decorative } from "@faire/design-tokens";
import { eventsThemeColors } from "@faire/web/slate/Theme/eventsThemeColors";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";

interface IBrandPromoTextProps {
  promoText: string;
  isHighlightedPromo?: boolean;
}

export const BrandPromoText: React.FC<IBrandPromoTextProps> = ({
  isHighlightedPromo,
  promoText,
}) => {
  return (
    <Typography
      variant={
        isHighlightedPromo ? "paragraphSansMedium" : "paragraphSansRegular"
      }
      color={
        isHighlightedPromo
          ? eventsThemeColors.faireMarket.promoText
          : Decorative.shade.orange
      }
    >
      {promoText}
    </Typography>
  );
};
